import styled from "styled-components";
import { dispositivo } from "../../../components/Dispositivos";

export const MainContainer = styled.div`
  width: 100%;
  background: #f8f9fa;
  padding: 20px;
  min-height: 80vh;
`;

export const ContainerTitle = styled.div`
  font-size: 12px;
  font-weight: normal;
  text-align: left;
  margin-bottom: 20px;
`;

export const ContainerTitleText = styled.h2`
  font-size: 1.5rem;
  font-weight: bold;
  color: #0C234C;
  margin: 0;
  border-bottom: 3px solid #0c8de3;
  display: inline-block;
  padding-bottom: 5px;
`;

export const ContainerBody = styled.div`
  width: 100%;
  background: #ffffff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.03), 0 1px 3px rgba(0, 0, 0, 0.02);
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
`;

export const FlexContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.25rem;
  margin-bottom: 20px;
  
  label {
    font-weight: 600;
    font-size: 0.9rem;
    color: #495057;
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 100%;
  }

  @media ${dispositivo.tablet} {
    flex-direction: row;
    align-items: flex-end;
    
    label {
      width: auto;
    }
  }
`;

export const StyledSelect = styled.select`
  border-radius: 8px;
  background-color: #ffffff;
  border: 1px solid #ced4da;
  outline: none;
  color: #495057;
  font-size: 0.95rem;
  width: 100%;
  height: 2.5rem;
  padding: 0 10px;
  transition: border-color 0.15s ease-in-out;
  
  &:focus {
    border-color: #0c8de3;
    box-shadow: 0 0 0 0.2rem rgba(12, 141, 227, 0.25);
  }

  @media ${dispositivo.tablet} {
    width: 22rem;
  }
`;

export const StyledInput = styled.input`
  border-radius: 8px;
  background-color: #ffffff;
  border: 1px solid #ced4da;
  outline: none;
  color: #495057;
  font-size: 0.95rem;
  width: 100%;
  height: 2.5rem;
  padding: 0 10px;
  transition: border-color 0.15s ease-in-out;
  
  &:focus {
    border-color: #0c8de3;
    box-shadow: 0 0 0 0.2rem rgba(12, 141, 227, 0.25);
  }

  @media ${dispositivo.tablet} {
    width: 12rem;
  }
`;

export const StyledButton = styled.button`
  height: 2.5rem;
  font-size: 0.95rem;
  font-weight: 600;
  width: 100%;
  border-radius: 8px;
  text-transform: uppercase;
  cursor: pointer;
  background-color: #0c8de3;
  color: #ffffff;
  border: none;
  transition: background-color 0.2s ease, transform 0.1s ease;
  
  &:hover {
    background-color: #0a74bc;
  }
  
  &:active {
    transform: scale(0.98);
  }

  @media ${dispositivo.tablet} {
    width: 10rem;
  }
`;

export const GridResumen = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.25rem;
  width: 100%;
  margin-bottom: 24px;

  @media ${dispositivo.tablet} {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 1200px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

export const CardResumen = styled.div`
  background-color: #ffffff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.02), 0 1px 3px rgba(0, 0, 0, 0.01);
  border: 1px solid #e9ecef;
  
  .card-title {
    font-size: 0.85rem;
    font-weight: 600;
    color: #6c757d;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 8px;
  }
  
  .card-value {
    font-size: 1.75rem;
    font-weight: 700;
    color: #0C234C;
    margin-bottom: 4px;
  }

  .card-desc {
    font-size: 0.8rem;
    color: #868e96;
  }
`;

export const FlexGridSection = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  margin-bottom: 24px;

  @media (min-width: 992px) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const SectionTitle = styled.h3`
  font-size: 1.15rem;
  font-weight: 600;
  color: #0C234C;
  margin-bottom: 16px;
  border-bottom: 2px solid #f1f3f5;
  padding-bottom: 8px;
`;

export const ProgressBarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 14px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const ProgressBarLabel = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 0.88rem;
  color: #495057;
  font-weight: 500;
  
  .label-left {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 6px;
  }
  
  .label-right {
    font-weight: 700;
    color: #0c8de3;
  }
`;

export const ProgressBarContainer = styled.div`
  width: 100%;
  height: 10px;
  background-color: #f1f3f5;
  border-radius: 5px;
  overflow: hidden;
`;

export const ProgressBarFill = styled.div`
  height: 100%;
  border-radius: 5px;
  width: ${props => props.percent}%;
  background: ${props => props.color || 'linear-gradient(90deg, #0c8de3, #67D2DC)'};
  transition: width 0.4s ease-out;
`;

export const TemplateList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 250px;
  overflow-y: auto;
  padding-right: 5px;
`;

export const TemplateItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  font-size: 0.85rem;
  
  .temp-name {
    font-weight: 600;
    color: #343a40;
    font-family: monospace;
  }
  
  .temp-count {
    background-color: #e7f5ff;
    color: #0c8de3;
    font-weight: 700;
    padding: 2px 8px;
    border-radius: 12px;
  }
`;

export const Tabla = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
`;

export const TablaHeader = styled.thead`
  background: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
`;

export const TablaHeaderTexto = styled.th`
  font-size: 0.85rem;
  font-weight: 600;
  color: #495057;
  padding: 12px;
  text-align: left;
`;

export const TablaBody = styled.tbody`
  background: #ffffff;
`;

export const TablaBodyRow = styled.tr`
  border-bottom: 1px solid #f1f3f5;
  
  &:hover {
    background-color: #f8f9fa;
  }
`;

export const TablaBodyTexto = styled.td`
  font-size: 0.85rem;
  color: #343a40;
  padding: 12px;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  
  &.preview-cell {
    white-space: normal;
    word-break: break-all;
  }
  
  .badge-type {
    background-color: #e9ecef;
    color: #495057;
    padding: 3px 6px;
    border-radius: 4px;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    
    &.type-template {
      background-color: #e7f5ff;
      color: #0c8de3;
    }
    &.type-text {
      background-color: #f4fce3;
      color: #74b816;
    }
  }
`;

export const PaginatorContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  font-size: 0.85rem;
  color: #6c757d;
  
  .btn-group {
    display: flex;
    gap: 8px;
  }
  
  button {
    padding: 4px 10px;
    border-radius: 4px;
    border: 1px solid #ced4da;
    background-color: #ffffff;
    cursor: pointer;
    
    &:disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
    
    &:not(:disabled):hover {
      background-color: #f8f9fa;
      border-color: #adb5bd;
    }
  }
`;

export const DetailFiltersContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 20px;
  background-color: #f8f9fa;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  
  label {
    font-weight: 600;
    font-size: 0.85rem;
    color: #495057;
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 100%;
  }

  @media ${dispositivo.tablet} {
    flex-direction: row;
    align-items: center;
    
    label {
      width: auto;
      flex: 1;
    }
  }
`;

export const ToggleButton = styled.button`
  background-color: #f1f3f5;
  color: #0c8de3;
  border: 1px solid #dee2e6;
  font-size: 0.95rem;
  font-weight: 600;
  padding: 12px 24px;
  border-radius: 8px;
  cursor: pointer;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #e7f5ff;
    border-color: #a5d8ff;
    color: #0a74bc;
  }
  
  &:active {
    transform: scale(0.99);
  }
`;

